// extracted by mini-css-extract-plugin
module.exports = {"root":"_0cbaba7d8a--root--Wpuay","item":"_0cbaba7d8a--item--tyrwq","tablet":"_0cbaba7d8a--tablet--WytWL","phone":"_0cbaba7d8a--phone--ijoRn"};